/*
 * Created by: cparaschiv
 * Date: 13.08.2013, 11:01
 */

TS.culture = function(code) {
    var culture;

    if (code !== undefined) {
        culture = TS.cultures[code] || TS.cultures['ro-RO'];
        TS.cultures.current = culture;
    } else {
        return TS.cultures.current;
    }
};